/**
 * SideNav.tsx — sidemeny (venstre)
 *
 * Ren React-komponent som erstatter cds-side-nav.
 * Responsiv sidemeny med lenker og utvidbare menyer.
 *
 * Props:
 * - expanded: om side-nav er utvidet (overlay på smale skjermer)
 * - ariaLabel: tilgjengelighet-label
 * - children: SideNavLink / SideNavMenu / SideNavDivider
 */

import { ReactNode } from 'react';
import styles from './side-nav.module.css';

interface SideNavProps {
  expanded: boolean;
  ariaLabel?: string;
  children: ReactNode;
}

export default function SideNav({ expanded, ariaLabel = 'Sidemeny', children }: SideNavProps) {
  return (
    <nav
      className={expanded ? styles.sideNavExpanded : styles.sideNav}
      aria-label={ariaLabel}
      aria-hidden={!expanded}
    >
      <ul className={styles.items}>
        {children}
      </ul>
    </nav>
  );
}
